import { useConfig } from '../auth'
import { redirectToProvider } from '../lib/allauth'
import BaseButton from '../components/BaseButton'
import GoogleOneTap from './GoogleOneTap'
import { styled, Box } from '@mui/material'

// Import Google and Facebook logos (you'll need to add the images to your project)
import GoogleLogo from '../assets/logos/web_light_rd_SI.svg' // Path to Google logo
import FacebookLogo from '../assets/logos/web_light_rd_ctn.svg' // Path to Facebook logo

// Custom styles for the buttons

const DefaultProviderButton = styled(BaseButton)({
  background: 'linear-gradient(#E91E63, #1F021C)', // Default theme gradient
  color: 'white',
  fontWeight: 'bold',
  margin: '10px',
  borderRadius: '20px',
  width: '100%',
  boxShadow: '0px 5px 10px -2px rgba(255, 105, 135, 0.6)',
  '&:hover': {
    backgroundColor: '#D81B60',
  },
});

const Logo = styled('img')({
  height: '80%', // Adjust height to fit nicely
});

export default function ProviderList (props) {
  const config = useConfig()
  const providers = config.data.socialaccount.providers
  if (!providers.length) {
    return null
  }

  const renderProviderButton = (provider) => {
    switch (provider.name) {
      case 'Google':
        return (
            <Logo src={GoogleLogo} alt="Google Logo" />
        )
      case 'Facebook':
        return (
            <Logo src={FacebookLogo} alt="Facebook Logo" />
        )
      default:
        return (
          <DefaultProviderButton
            onClick={() => redirectToProvider(provider.id, props.callbackURL, props.process)}
          >
            {provider.name}
          </DefaultProviderButton>
        )
    }
  }

  return (
    <>
      <GoogleOneTap process={props.process} />
      <Box display="flex" flexDirection="column" alignItems="center">
        {providers.map(provider => (
          <li key={provider.id} style={{ listStyle: 'none', width: '100%' }}>
            {renderProviderButton(provider)}
          </li>
        ))}
      </Box>
    </>
  )
}